/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Channels } from './channels';


export interface SendNotificationRequest { 
    identifier: string;
    channel?: Channels;
    recipient: string;
    recipientId?: string | null;
    userData?: string | null;
    attachments?: Array<Blob> | null;
}



